import Listing from "./scripts/components/Listing";
import { format } from "date-fns";

class ArchiveListing {
    constructor(element) {
        this.el = element;
        this.form = document.getElementById("archive-filters-form");
        this.init();
    }

    init() {
        // console.log('Archive listing element:', this.el);
        // console.log('Archive form:', this.form);

        if (this.el) {
            this.listing = new Listing({
                root: this.el,
                form: this.form,
                listingId: "archive",
                promoInterval: 4,
                pagination: {
                    type: "numbered",
                    perPage: 6,
                },
                html: "/wp-content/uploads/archive.html",
                json: "/wp-content/uploads/archive.json",
                objectName: {
                    singular: "event",
                    plural: "events",
                },
                callback: () => {
                    console.log("[ArchiveListing]: ", this.listing);
                },
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("archive-listing");

    if (element) {
        new ArchiveListing(element);
    }
});
